// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import TitledSection from "@synd/App/Components/TitledSection/TitledSection";
import { xHasRole, xIsAuthenticated } from "@synd/App/Store/Selectors/GeneralSelectors";
import WidgetRouteTruck from "@synd/XDL/Icons/WidgetRouteTruck";
import { USER_ROLES, XNGAGE_CUSTOM_WIDGET } from "@synd/XDL/constants";
import React, { FC } from "react";
import { shallowEqual } from "react-redux";

export interface RouteTrucksStyles {
    message?: TypographyPresentationProps;
}

export const routeTrucksStyles: RouteTrucksStyles = {};

export const RouteTrucks: FC = () => {
    const styles = routeTrucksStyles;
    const { isAuthenticated, routeTruckDay, isRetailerUser } = useAppSelector(state => {
        const session = getSession(state);
        const currentBillTo = getBillToState(state, session.billToId).value;
        return {
            isAuthenticated: xIsAuthenticated(state),
            routeTruckDay: currentBillTo?.properties?.routeTruckDay,
            isRetailerUser: xHasRole(state, USER_ROLES.RETAILER),
        };
    }, shallowEqual);

    if (!isAuthenticated || !routeTruckDay || isRetailerUser) {
        return null;
    }

    return (
        <TitledSection
            icon={WidgetRouteTruck}
            title={routeTruckDay}
            secondaryText={translate("Route Truck")}
            iconSize={23}
        >
            <Typography {...styles.message}>{siteMessage("Custom_Route_Truck_Message")}</Typography>
        </TitledSection>
    );
};

const widgetModule: WidgetModule = {
    component: RouteTrucks,
    definition: {
        group: XNGAGE_CUSTOM_WIDGET,
        icon: "link",
        fieldDefinitions: [],
    },
};

export default widgetModule;
